"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var refs_exports = {};
__export(refs_exports, {
  Refs: () => Refs
});
module.exports = __toCommonJS(refs_exports);
var import_core = require("@hcengineering/core");
class Refs {
  constructor(getHierarchy) {
    this.getHierarchy = getHierarchy;
  }
  static {
    __name(this, "Refs");
  }
  // A map of _class to documents.
  documentRefs = /* @__PURE__ */ new Map();
  updateDocuments(q, docs, clean = false, authoritative = false) {
    if (q.options?.projection !== void 0) {
      return;
    }
    const params = ":" + JSON.stringify(q.options?.lookup ?? {}) + ":" + JSON.stringify(q.options?.associations ?? {});
    for (const d of docs) {
      const classKey = import_core.Hierarchy.mixinOrClass(d) + params;
      let docMap = this.documentRefs.get(classKey);
      if (docMap === void 0) {
        if (clean) {
          continue;
        }
        docMap = /* @__PURE__ */ new Map();
        this.documentRefs.set(classKey, docMap);
      }
      const existing = docMap.get(d._id);
      if (existing === void 0) {
        if (!clean) {
          docMap.set(d._id, { doc: d, queries: /* @__PURE__ */ new Set([q.id]), lastUsed: d.modifiedOn });
        }
        continue;
      }
      if (clean) {
        existing.queries.delete(q.id);
        if (existing.queries.size === 0) {
          docMap.delete(d._id);
          continue;
        }
      }
      if (!clean) {
        existing.queries.add(q.id);
      }
      if (authoritative || existing.lastUsed <= d.modifiedOn) {
        existing.doc = d;
        existing.lastUsed = d.modifiedOn;
      }
    }
  }
  findFromDocs(_class, query, options) {
    if (typeof query._id === "string") {
      const desc = this.getHierarchy().getDescendants(_class);
      for (const des of desc) {
        const classKey = des + ":" + JSON.stringify(options?.lookup ?? {}) + ":" + JSON.stringify(options?.associations ?? {});
        const doc = this.documentRefs.get(classKey)?.get(query._id)?.doc;
        if (doc !== void 0) {
          const q = (0, import_core.matchQuery)([doc], query, _class, this.getHierarchy());
          if (q.length > 0) {
            return (0, import_core.toFindResult)(this.getHierarchy().clone([doc]), 1);
          }
        }
      }
    }
    if (options?.limit === 1 && options.total !== true && options?.sort === void 0 && options?.projection === void 0) {
      const classKey = _class + ":" + JSON.stringify(options?.lookup ?? {}) + ":" + JSON.stringify(options?.associations ?? {});
      const docs = this.documentRefs.get(classKey);
      if (docs !== void 0) {
        const _docs = Array.from(docs.values()).map((it) => it.doc);
        const q = (0, import_core.matchQuery)(_docs, query, _class, this.getHierarchy());
        if (q.length > 0) {
          return (0, import_core.toFindResult)(this.getHierarchy().clone([q[0]]), 1);
        }
      }
      if (options.lookup === void 0 && options.associations === void 0) {
        const keys = Array.from(this.documentRefs.keys());
        for (const key of keys) {
          if (key.startsWith(_class + ":")) {
            const docs2 = this.documentRefs.get(key);
            if (docs2 !== void 0) {
              const _docs = Array.from(docs2.values()).map((it) => it.doc);
              const q = (0, import_core.matchQuery)(_docs, query, _class, this.getHierarchy());
              if (q.length > 0) {
                const clonedDoc = this.getHierarchy().clone(q[0]);
                const { $lookup, $associations, ...clean } = clonedDoc;
                if (this.getHierarchy().isMixin(_class)) {
                  return (0, import_core.toFindResult)([this.getHierarchy().as(clean, _class)], 1);
                }
                return (0, import_core.toFindResult)([clean], 1);
              }
            }
          }
        }
      }
    }
    return null;
  }
}
//# sourceMappingURL=refs.js.map
